import * as React from 'react'
import { Component } from "react";
import styled from 'styled-components'
import Slider from "react-slick";

const imgSlider01 = require('src/assets/wizard/contact/stefan.png')
const imgSlider02 = require('src/assets/wizard/contact/natascha.png')
const imgSlider03 = require('src/assets/wizard/contact/lukas.png')
const imgSlider04 = require('src/assets/wizard/contact/tamara.png')

export default class SideBarSlider extends Component {
    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
        };
        return (
            <div>
                <CustomSlider {...settings}>
                    <div>
                        <img src={imgSlider01} />
                        <h4>Stefan Atz</h4>
                        <p>Geschäftsführer</p>
                    </div>
                    <div>
                        <img src={imgSlider02} />
                        <h4>Natascha Kvicsala</h4>
                        <p>Bestattungsexperte</p>
                    </div>
                    <div>
                        <img src={imgSlider03} />
                        <h4>Lukas Wurzinger</h4>
                        <p>Bestattungsexperte</p>
                    </div>
                    <div>
                        <img src={imgSlider04} />
                        <h4>Tamara Loesch</h4>
                        <p>Vorsorgeexpertin</p>
                    </div>
                </CustomSlider>
            </div>
        );
    }
}


const CustomSlider = styled(Slider)`
    max-width: 300px !important;
    height: 200px;
    margin: 0 auto;
    margin-bottom: 40px;


    .slick-slide{
        display: flex !important;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        div{
            width: 100% !important;
        }
        
        img{

            margin: 8px auto;
        }

        h4{
            width: 100%;
            font-size: 16px;
            text-align: center;
            font-style: normal;
            font-weight: 700;
            margin: 0;
        }
        p{
            width: 100%;
            font-size: 15px;
            line-height: 1.4;
            font-style: italic;
            text-align: center;
            margin-bottom: 14px;
        }
        
    }

    .slick-dots {
        display: flex !important;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        ul{
            position: relative;
            top: -50px;
            padding: 0px;
            margin: 0px;
        }

        li{
            display: inline;
            margin: 0px !important;
        }
    }
`;


// WEBPACK FOOTER //
// ./src/components/molecules/wizard/SideBarSlider.tsx